import { useWeightMeasurementSystemContext } from '../../../contexts/WeightMeasurementUnitsContext';
import {
  WeightMeasurementSystem,
  WeightMeasurementUnits,
} from '../../../constants/measurementUnits.constants';

export default function useChickenDashboardUnits() {
  const { system } = useWeightMeasurementSystemContext();

  switch (system) {
    case WeightMeasurementSystem.Metric:
      return WeightMeasurementUnits.Kilograms;
    case WeightMeasurementSystem.Imperial:
      return WeightMeasurementUnits.Pounds;
  }
}
